import { SHARED_REACT_QUERY_CONFIG } from "../../constants/reactQuery.constant";
import { notificationsAPI } from "../../services/notifications/notificactions.service";

export const NOTIFICATIONS_QUERY = "notifications";
export const NOTIFICATIONS_QUERY_CONFIG = SHARED_REACT_QUERY_CONFIG;

export const notificationsQuery = async () => {
  const request = await notificationsAPI();
  return request.data;
};
